var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: '800px',width:'100%'}),attrs:{"id":"echart-network"}})
}
var staticRenderFns = []

export { render, staticRenderFns }